import { FormGroup, FormArray } from "@angular/forms";

export class FormComponent {
  constructor(public formGroup: FormGroup) {}

  public errorMessage(key: string): string {
    const formControl = this.formGroup.get(key);
    if (formControl.valid) {
      return "";
    }
    const [firstError] = Object.keys(formControl.errors);
    return ValidationMessages[firstError];
  }

  public showError(key: string, index?: number): boolean {
    if (!this.formGroup.get(key)) {
      console.log('No control for key=' + key);
      return;
    }

    if (index !== null && typeof index !== "undefined") {
      let formArray = this.formGroup.get(key) as FormArray;
      return !formArray.at(index).valid && formArray.at(index).touched;
    }

    return !this.formGroup.get(key).valid && this.formGroup.get(key).touched;
  }
}

const ValidationMessages = {
  required: "Dit veld is verplicht",
  email: "Dit is geen geldig e-mail adres",
  min: "Voer een hoger aantal in",
  max: "Voer een kleiner aantal in",
};
